import UsersPageComponent from "./components/UsersPageComponent";

import axios from "axios";

const fetchUsers = async (abctrl) => {
    const { data } = await axios.get("/api/users", {
        signal: abctrl.signal,
    });
    return data
}

const deleteUser = async (userId) => {
    const { data } = await axios.delete(`/api/users/${userId}`);
    return data
}

const getDeliveryBooks = async () => {
    const { data } = await axios.get("/api/deliveryBooks");
    return data
}

const AdminUsersPage = () => {
    return <UsersPageComponent fetchUsers={fetchUsers} deleteUser={deleteUser} getDeliveryBooks={getDeliveryBooks} />;
};

export default AdminUsersPage;

